module.exports = __webpack_public_path__ + "static/media/table-l.50970c9b.png";